import React, { useReducer, useEffect } from "react";
import { Link as DomLink, useLocation } from "react-router-dom";
import CertDiamondTable from "./CertDiamondTable";
import CertDiamondFilters from "./CertDiamondFilters";
import states from "../../utils/stateHandlers/initialStates";
import { diamondReducer } from "../../utils/stateHandlers/reducers";
import { DiamondSearchContext } from "../../utils/stateHandlers/contexts";
import { Mobile, Default } from "../../utils/deviceHelpers";
import api from "../../utils/api";
import { storage } from "../../utils";
import {
  hiddenColumns,
  hiddenMobile,
  hiddenTablet,
  hiddenForSidePanel,
} from "../../utils/constants";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";
import MenuItem from "@mui/material/MenuItem";
import { Select as MUISelect } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import _ from "lodash";
import CertDiamondAddToCartPreview from "./CertDiamondAddToCartPreview";
import CertDiamondSingleAddToCartPreview from "./CertDiamondSingleAddToCartPreview";

export default function CertDiamondSearchLanding(props) {
  const [diamondState, dispatch] = useReducer(
    diamondReducer,
    states.initialDiamondSearchState
  );
  const {
    currentTab,
    diamonds,
    diamondCount,
    recentlyViewed,
    selected,
    searchQuery,
    pageLoaded,
    resultsLoaded,
    openCartPreview,
    openCartPreviewSingle,
  } = diamondState;
  const loggedIn = storage.getStorageItem("authToken");
  const sendTo = useLocation();

  const mapResults = (data) => {
    const mappedResults = [];
    _.forEach(data.results, function (d) {
      const newD = _.assignIn({ Checked: false }, d);
      mappedResults.push(newD);
    });
    data.results = mappedResults;
    dispatch({
      type: "diamonds",
      payload: {
        diamonds: data.results,
        diamondCount: data.count,
      },
    });
  };

  const handleTabChange = (event, newTab) => {
    dispatch({ type: "setTab", payload: newTab });
    dispatch({ type: "setOpenPanel", payload: false });
    dispatch({ type: "setSelectedDiamond", payload: {} });
  };

  const Chips = () => (
    <Typography variant="body3" sx={{ marginBottom: "1rem" }}>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        <Chip
          label={`${selected.length} Selected`}
          sx={{ backgroundColor: "white" }}
          className={`${selected && selected.length > 0 ? "" : "invisible"}`}
        />
        <Chip
          label="Clear All"
          onClick={clearAllSelected}
          className={`${selected && selected.length > 0 ? "" : "invisible"}`}
        />
        <Default>
          <Chip
            color="success"
            label="Add to Cart"
            disabled={loggedIn ? false : true}
            className={`${selected && selected.length > 0 ? "" : "invisible"}`}
            onClick={(e) => {
              dispatch({ type: "setOpenCartPreview", payload: true });
            }}
          />
        </Default>
        <Chip
          label="Compare"
          value="Selected"
          className={`${selected && selected.length > 0 ? "" : "invisible"}`}
          onClick={(event) => handleTabChange(event, "Selected")}
        />
        <Divider orientation="vertical" flexItem />
        <Chip
          color="warning"
          label="Reset Filters"
          onClick={() => resetFilters()}
        />
        {/* <Chip label="Download PDF" className="font-size-regular"> */}
        {/* <PDFDownloadLink document={createPDF} fileName="something.pdf">
          {({ blob, url, loading, error }) =>
            loading ? "Loading document..." : "Download now!"
          }
        </PDFDownloadLink> */}
        {/* </Chip> */}
        {!loggedIn && (
          <DomLink
            to={{
              pathname: "/login",
              state: { sendTo: sendTo.pathname },
            }}
          >
            <Button
              variant="contained"
              color="error"
              size="small"
              sx={{ marginTop: "unset" }}
            >
              Login For pricing
            </Button>
          </DomLink>
        )}
      </Stack>
    </Typography>
  );

  function clearAllSelected() {
    dispatch({ type: "setSelected", payload: [] });
    storage.setSessionStorageItem("hsSelectedData", JSON.stringify([]));
    _.forEach(diamonds, (d) => {
      if (d.Checked) {
        d.Checked = false;
      }
    });
  }

  function resetFilters() {
    dispatch({
      type: "clearFilters",
      payload: [
        {
          name: "MinedOrLab",
          values: [{ name: "M" }],
        },
      ],
    });
  }

  function nextPage() {
    const currentPage = searchQuery.page;
    dispatch({ type: "updatePage", payload: currentPage + 1 });
  }

  function prevPage() {
    const currentPage = searchQuery.page;
    dispatch({ type: "updatePage", payload: currentPage - 1 });
  }

  function formatPriceFieldsForNoAuth(field) {
    const newField = {
      name: field.name,
      search_order: field.name === "HooverPrice" ? 20 : null,
      results_order:
        field.name === "HooverPrice"
          ? 190
          : field.name === "CalcPricePerCarat"
          ? 180
          : null,
      label:
        field.name === "HooverPrice"
          ? "Price"
          : field.name === "CalcPricePerCarat"
          ? "Price P/C"
          : "",
    };
    return newField;
  }

  useEffect(() => {
    api.fetch("diamonds/fields").then((response) => {
      const standard = _.filter(response.data, function (field) {
        return (
          !field.advanced &&
          field.search_order &&
          field.name !== "AsGrown" &&
          field.name !== "ScsGrower" &&
          field.name !== "ShipsSameDay" &&
          field.name !== "CalcPricePerCarat"
        );
      });
      const priceFilter = _.find(response.data, function (field) {
        return field.name === "HooverPrice";
      });
      const formatPriceFilter = formatPriceFieldsForNoAuth(priceFilter);
      const sortedFilters = _.sortBy(
        _.uniqBy(_.concat(standard, formatPriceFilter), function (field) {
          return field.name;
        }),
        function (field) {
          return field.search_order;
        }
      );
      const advanced = _.filter(response.data, function (field) {
        return (
          field.advanced === true &&
          field.name !== "AsGrown" &&
          field.name !== "ScsGrower" &&
          field.name !== "ShipsSameDay" &&
          field.name !== "CalcPricePerCarat"
        );
      });
      const headers = _.filter(response.data, function (field) {
        return field.results_order && !hiddenColumns.includes(field.name);
      });
      const pricePerCaratField = _.find(response.data, function (field) {
        return formatPriceFieldsForNoAuth(field.name === "CalcPricePerCarat");
      });
      const formatPerCaratField =
        formatPriceFieldsForNoAuth(pricePerCaratField);
      const allHeaders = _.uniqBy(
        _.concat(headers, formatPriceFilter, formatPerCaratField),
        function (field) {
          return field.name;
        }
      );
      const sortedHeaders = _.sortBy(allHeaders, function (header) {
        return header.results_order;
      });
      const sidePanelHeaders = _.filter(sortedHeaders, function (header) {
        return !hiddenForSidePanel.includes(header.name);
      });
      const mobileHeaders = _.filter(sortedHeaders, function (header) {
        return !hiddenMobile.includes(header.name);
      });
      const tabletHeaders = _.filter(sortedHeaders, function (header) {
        return !hiddenTablet.includes(header.name);
      });
      dispatch({
        type: "setFilters",
        payload: {
          filters: sortedFilters,
          advancedFilters: advanced,
          tableHeaders: sortedHeaders,
          mobileTableHeaders: mobileHeaders,
          tabletTableHeaders: tabletHeaders,
          sidePanelTableHeaders: sidePanelHeaders,
        },
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "resultsLoaded", payload: false });
    api
      .post(`diamonds/search`, {
        fields: searchQuery.fields,
        page: searchQuery.page,
        size: searchQuery.size,
        sort: searchQuery.sort,
      })
      .then((res) => {
        mapResults(res.data);
        dispatch({ type: "resultsLoaded", payload: true });
        dispatch({ type: "pageLoaded", payload: true });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  useEffect(() => {
    const rvStorage = JSON.parse(
      storage.getSessionStorageItem("hsRecentlyViewedData")
    );
    const selectedStorage = JSON.parse(
      storage.getSessionStorageItem("hsSelectedData")
    );
    if (rvStorage && rvStorage.length > 0) {
      dispatch({ type: "setRecentlyViewed", payload: rvStorage });
    }
    if (selectedStorage && selectedStorage.length > 0) {
      dispatch({ type: "setSelected", payload: selectedStorage });
      //loop through search results and check selected
      //add if statement here to check if the diamond is still available for sale
      _.forEach(selectedStorage, (s) => {
        _.map(diamonds, (r) => {
          if (s.HooverStockId === r.HooverStockId) {
            r.Checked = true;
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diamonds]);

  useEffect(() => {
    if (recentlyViewed.length > 0) {
      dispatch({ type: "setRecentlyViewed", payload: recentlyViewed });
      storage.setSessionStorageItem(
        "hsRecentlyViewedData",
        JSON.stringify(recentlyViewed)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recentlyViewed]);

  useEffect(() => {
    if (selected.length > 0) {
      dispatch({ type: "setSelected", payload: selected });
      dispatch({ type: "setCartPreview", payload: selected });
      storage.setSessionStorageItem("hsSelectedData", JSON.stringify(selected));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <DiamondSearchContext.Provider value={{ diamondState, dispatch }}>
      {!pageLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          <Mobile>
            <Stack>
              <Grid container direction="row" justifyContent="center">
                <Typography
                  variant="h1"
                  textAlign="center"
                  sx={{ marginRight: "unset", marginBottom: "2rem" }}
                >
                  Certified Diamond Search
                </Typography>
              </Grid>
              <CertDiamondFilters />
              <TabContext value={currentTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    className="float-right"
                    spacing={3}
                  >
                    {currentTab === "Results" && (
                      <>
                        <Chip
                          color="warning"
                          label="Reset Filters"
                          onClick={() => resetFilters()}
                        />
                      </>
                    )}
                  </Stack>
                  <TabList onChange={handleTabChange} textColor="inherit">
                    <Tab
                      label={`Results (${
                        diamondCount > 8000 ? "8000+" : diamondCount
                      })`}
                      value="Results"
                      className="font-size-regular"
                    />
                    <Tab
                      label={`Recently Viewed (${
                        recentlyViewed.filter((x) => x > "").length
                      })`}
                      value="RecentlyViewed"
                      className="font-size-regular"
                    />
                  </TabList>
                </Box>
                <TabPanel value="Results">
                  {!resultsLoaded ? (
                    <Typography variant="h1" sx={{ width: "100%" }}>
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </Typography>
                  ) : (
                    <>
                      <CertDiamondTable
                        diamonds={diamonds}
                        loggedIn={loggedIn}
                      />
                    </>
                  )}
                  <Stack
                    direction="row"
                    alignItems="center"
                    className="float-right"
                    spacing={3}
                    sx={{ marginTop: "1rem" }}
                  >
                    {searchQuery.page > 1 && (
                      <ChevronLeftIcon
                        onClick={() => prevPage()}
                        className="cursor-pointer"
                      />
                    )}
                    <Typography variant="body3">
                      Page {searchQuery.page}
                    </Typography>
                    {diamondCount > searchQuery.page * searchQuery.size && (
                      <ChevronRightIcon
                        onClick={() => nextPage()}
                        className="cursor-pointer"
                      />
                    )}
                    <Divider orientation="vertical" flexItem />
                    <Typography variant="body3">Results Per Page: </Typography>
                    <MUISelect
                      size="small"
                      value={searchQuery.size}
                      onChange={(event) =>
                        dispatch({
                          type: "updateSize",
                          payload: event.target.value,
                        })
                      }
                    >
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </MUISelect>
                  </Stack>
                </TabPanel>
                <TabPanel value="RecentlyViewed">
                  <CertDiamondTable
                    diamonds={recentlyViewed}
                    loggedIn={loggedIn}
                  />
                </TabPanel>
              </TabContext>
            </Stack>
          </Mobile>
          <Default>
            <Stack>
              <Grid container direction="row" justifyContent="center">
                <Typography
                  variant="h1"
                  sx={{ marginRight: "unset", marginBottom: "2rem" }}
                >
                  Certified Diamond Search
                </Typography>
              </Grid>
              <CertDiamondFilters />
              <TabContext value={currentTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    className="float-right"
                    spacing={3}
                  >
                    {currentTab === "Results" && <>{Chips()}</>}
                  </Stack>
                  <TabList onChange={handleTabChange} textColor="inherit">
                    <Tab
                      label={`Results (${
                        diamondCount > 8000 ? "8000+" : diamondCount
                      })`}
                      value="Results"
                      className="font-size-regular"
                    />
                    <Tab
                      label={`Recently Viewed (${
                        recentlyViewed.filter((x) => x > "").length
                      })`}
                      value="RecentlyViewed"
                      className="font-size-regular"
                    />
                    <Tab
                      label={`Selected (${
                        selected.filter((x) => x > "").length
                      })`}
                      value="Selected"
                      className="font-size-regular"
                    />
                  </TabList>
                </Box>
                <TabPanel value="Results">
                  {!resultsLoaded ? (
                    <Typography variant="h1" sx={{ width: "100%" }}>
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </Typography>
                  ) : (
                    <CertDiamondTable diamonds={diamonds} loggedIn={loggedIn} />
                  )}
                  <Stack
                    direction="row"
                    alignItems="center"
                    className="float-right"
                    spacing={3}
                    sx={{ marginTop: "1rem" }}
                  >
                    {searchQuery.page > 1 && (
                      <ChevronLeftIcon
                        onClick={() => prevPage()}
                        className="cursor-pointer"
                      />
                    )}
                    <Typography variant="body3">
                      Page {searchQuery.page}
                    </Typography>
                    {diamondCount > searchQuery.page * searchQuery.size && (
                      <ChevronRightIcon
                        onClick={() => nextPage()}
                        className="cursor-pointer"
                      />
                    )}
                    <Divider orientation="vertical" flexItem />
                    <Typography variant="body3">Results Per Page: </Typography>
                    <MUISelect
                      size="small"
                      value={searchQuery.size}
                      onChange={(event) =>
                        dispatch({
                          type: "updateSize",
                          payload: event.target.value,
                        })
                      }
                    >
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </MUISelect>
                  </Stack>
                </TabPanel>
                <TabPanel value="RecentlyViewed">
                  <CertDiamondTable
                    diamonds={recentlyViewed}
                    loggedIn={loggedIn}
                  />
                </TabPanel>
                <TabPanel value="Selected">
                  {selected && (
                    <CertDiamondTable diamonds={selected} loggedIn={loggedIn} />
                  )}
                </TabPanel>
              </TabContext>
            </Stack>
          </Default>
        </>
      )}
      {openCartPreview && <CertDiamondAddToCartPreview />}
      {openCartPreviewSingle && <CertDiamondSingleAddToCartPreview />}
    </DiamondSearchContext.Provider>
  );
}
